import { MenuItem } from '@card-software/library';
import { UserGroup } from './models/authorization/enum/user-group.enum';

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Quality Control',
    routerLink: '/quality-control',
    redirect: false,
    children: [
      {
        displayName: 'Roll QC',
        routerLink: '/rolls-qc',
        redirect: true,
        roles: [UserGroup.RollQCAdmin, UserGroup.RollQCEditor, UserGroup.RollQCViewer],
      },
    ],
  },
  {
    displayName: 'Import',
    routerLink: '/import',
    redirect: false,
    children: [
      {
        displayName: 'Warehouse Imports',
        routerLink: '/warehouse-imports',
        redirect: true,
        roles: [
          UserGroup.YarnWarehouseImportsEditor,
          UserGroup.YarnWarehouseImportsAdmin,
          UserGroup.YarnWarehouseImportsSupervisor,
          UserGroup.YarnWarehouseImportsViewer,
        ],
      },
    ],
  },
  {
    displayName: 'Inventory Search/Balances',
    routerLink: '/inventory-search-balances',
    redirect: false,
    children: [
      {
        displayName: 'Items Inventory',
        routerLink: '/items-inventory',
        redirect: true,
        roles: [UserGroup.ItemsInventoryAdmin, UserGroup.ItemsInventoryViewer],
      },
      {
        displayName: 'Roll Production Inventory',
        routerLink: '/production-inventory',
        redirect: true,
        roles: [UserGroup.ProductionInventoryViewer, UserGroup.ProductionInventoryAdmin],
      },
      {
        displayName: 'Inventory Sessions',
        routerLink: '/inventory-sessions',
        redirect: true,
        roles: [UserGroup.InventorySessionViewer, UserGroup.InventorySessionEditor, UserGroup.InventorySessionAdmin],
      },
      {
        displayName: 'Kardex Audit',
        routerLink: '/kardex-audit',
        redirect: true,
        roles: [UserGroup.KardexAuditViewer, UserGroup.KardexAuditAdmin],
      },
    ],
  },
  {
    displayName: 'Production Inv. Movements',
    routerLink: '/inventory-movements',
    redirect: false,
    children: [
      {
        displayName: 'Return Surplus',
        routerLink: '/return-surplus',
        redirect: true,
        roles: [UserGroup.ReturnSurplusViewer, UserGroup.ReturnSurplusAdmin],
      },
      {
        displayName: 'Internal Yarn Requisition',
        routerLink: '/yarn-requisitions',
        redirect: true,
        roles: [
          UserGroup.InternalYarnRequisitionAllViewer,
          UserGroup.InternalYarnRequisitionKnittingViewer,
          UserGroup.InternalYarnRequisitionWarehouseViewer,
          UserGroup.InternalYarnRequisitionKnittingEditor,
          UserGroup.InternalYarnRequisitionWarehouseEditor,
          UserGroup.InternalYarnRequisitionAdmin,
        ],
      },
      {
        displayName: 'Requisition',
        routerLink: '/requisitions',
        redirect: true,
        roles: [UserGroup.RequisitionViewer, UserGroup.RequisitionEditor, UserGroup.RequisitionAdmin],
      },
    ],
  },
  {
    displayName: 'Lot Item Management',
    routerLink: '/lot-item-management',
    redirect: false,
    children: [
      {
        displayName: 'Split Lot Items',
        routerLink: '/split-lot-items',
        redirect: true,
        roles: [UserGroup.SplitLotItemViewer, UserGroup.SplitLotItemAdmin],
      },
      {
        displayName: 'Merge Lot Items',
        routerLink: '/merge-lot-items',
        redirect: true,
        roles: [UserGroup.MergeLotItemViewer, UserGroup.MergeLotItemAdmin],
      },
    ],
  },
  {
    displayName: 'Lot Item Inv. Movements',
    routerLink: '/lot-item-movements',
    redirect: false,
    children: [
      {
        displayName: 'Inventory Adjustment',
        routerLink: '/inventory-adjustment',
        redirect: true,
        roles: [UserGroup.InventoryAdjustmentAdmin],
      },
      {
        displayName: 'Greige Transfer Units',
        routerLink: '/transfer-units',
        redirect: true,
        roles: [UserGroup.TransferUnitViewer, UserGroup.TransferUnitEditor, UserGroup.TransferUnitReceiver, UserGroup.TransferUnitAdmin],
      },
      {
        displayName: 'FG Transfers',
        routerLink: '/finished-good-transfers',
        redirect: true,
        roles: [
          UserGroup.FinishedGoodsTransferViewer,
          UserGroup.FinishedGoodsTransferEditor,
          UserGroup.FinishedGoodsTransferReceiver,
          UserGroup.FinishedGoodsTransferAdmin,
        ],
      },
      {
        displayName: 'Relocate Lot Items',
        routerLink: '/lot-item-relocation-details',
        redirect: true,
        roles: [UserGroup.LotItemRelocationViewer, UserGroup.LotItemRelocationAdmin],
      },
      {
        displayName: 'Lot Item Transfer',
        routerLink: '/lot-item-transfers',
        redirect: true,
        roles: [
          UserGroup.LotItemTransferViewer,
          UserGroup.LotItemTransferEditor,
          UserGroup.LotItemTransferReceiver,
          UserGroup.LotItemTransferAdmin,
          UserGroup.GreigeSampleSender,
          UserGroup.GreigeSampleReceiver,
          UserGroup.FinishedSampleSender,
          UserGroup.FinishedSampleReceiver,
        ],
      },
    ],
  },
  {
    displayName: 'Supply Warehouse',
    routerLink: '/supply-warehouse',
    redirect: false,
    children: [
      {
        displayName: 'Supply Request',
        routerLink: '/supply-request',
        redirect: true,
        roles: [UserGroup.SupplyRequestViewer, UserGroup.SupplyRequestAdmin],
      },
      {
        displayName: 'Supply Warehouse',
        routerLink: '/supply-warehouse',
        roles: [
          UserGroup.SupplyWarehouseViewer,
          UserGroup.SupplyWarehouseAdmin,
          UserGroup.SupplyWarehouseInternalReturnsAdmin,
          UserGroup.SupplyWarehouseProviderReturnAdmin,
        ],
        redirect: true,
      },
    ],
  },
  {
    displayName: 'Reporting',
    routerLink: '/reporting',
    redirect: false,
    children: [
      {
        displayName: 'Inventory Reports',
        routerLink: '/reporting',
        redirect: true,
        roles: [UserGroup.InventoryReportingViewer, UserGroup.InventoryReportingAdmin],
      },
      {
        displayName: 'Balance Snapshot Runs',
        routerLink: '/balance-snapshot-runs',
        redirect: true,
        roles: [UserGroup.InventoryBalanceAdmin, UserGroup.InventoryBalanceViewer],
      },
    ],
  },
  {
    displayName: 'Export',
    routerLink: '/export',
    redirect: false,
    children: [
      {
        displayName: 'Dispatch Instruction',
        routerLink: '/dispatch-instructions',
        redirect: true,
        roles: [
          UserGroup.DispatchInstructionViewer,
          UserGroup.DispatchInstructionCustomerServiceEditor,
          UserGroup.DispatchInstructionExportEditor,
          UserGroup.DispatchInstructionAdmin,
        ],
      },
      {
        displayName: 'Second Quality Dispatch',
        routerLink: '/second-quality-dispatches',
        redirect: true,
        roles: [UserGroup.SecondQualityDispatchViewer, UserGroup.SecondQualityDispatchEditor, UserGroup.SecondQualityDispatchAdmin],
      },
      {
        displayName: 'Remission Guide',
        routerLink: '/remission-guides',
        redirect: true,
        roles: [UserGroup.RemissionGuideViewer, UserGroup.RemissionGuideAdmin, UserGroup.RemissionGuideEditor],
      },
    ],
  },
  {
    displayName: 'Admin',
    routerLink: '/admin',
    redirect: false,
    children: [
      {
        displayName: 'Inventory Type',
        routerLink: '/inventory-type',
        redirect: true,
        roles: [UserGroup.InventoryTypesAdmin, UserGroup.InventoryTypesViewer],
      },
      {
        displayName: 'Locations',
        routerLink: '/locations',
        redirect: true,
        roles: [UserGroup.SupplyWarehouseAdmin],
      },
      {
        displayName: 'Business Lot Numbers',
        routerLink: '/business-lot-numbers',
        redirect: true,
        roles: [UserGroup.BusinessLotNumbersViewer, UserGroup.BusinessLotNumbersAdmin],
      },
    ],
  },
];
